import { HeaderLogoItemProps } from 'libs/contentful/props';
import { HeaderLogoItemVariants } from 'types/constants';
import { RemoteImage } from '@1debit/chimekit';
import { getIconByKey, IconToken } from '@1debit/icons';
import { icons } from '@1debit/chime-assets';
import Media from '../shared/Media/Media';
import { pascalToSnake } from 'utils/formatters';

const getIconName = (icon: IconToken | undefined): IconToken => {
  let realIconName = pascalToSnake(icon!);
  if (!(realIconName in icons)) {
    realIconName = 'help';
  }
  return realIconName as IconToken;
};

const HeaderLogoItem = ({ variant, image, aspectRatio, illustration, icon }: HeaderLogoItemProps) => {
  const iconName = icon && getIconName(icon);
  const Icon = getIconByKey(iconName!);
  switch (variant) {
    case HeaderLogoItemVariants.IMAGE:
      return (
        <Media media={image!} aspectRatio={aspectRatio} className="max-h-8 w-auto p-0.5 rounded-none" sizes="100px" />
      );

    case HeaderLogoItemVariants.ILLUSTRATION:
      return (
        <div className="mb-1.5">
          <RemoteImage token={illustration!} alt="Illustration ChimeKit" />
        </div>
      );
    case HeaderLogoItemVariants.ICON:
      return <Icon className="size-(--ck-icon-size) ml-1 mr-1" data-testid="headerLogoIcon" />;
    default:
      return <></>;
  }
};

export default HeaderLogoItem;
